import { metaObject } from "@/config/site.config";
import CategoryListTable from "@/app/shared/categories/list/table";
import { Category } from "@/types";
import { useState, useEffect } from "react";
import { addCategory, fetchCategories } from "@/server/api-services";
import CategoryPageHeader from "./page-header";
import toast from "react-hot-toast";

// export const metadata = {
//     ...metaObject("Logistics"),
// };

export default function CategoryListPage() {
    const [categories, setCategorys] = useState<Category[]>([]);

    useEffect(() => {
        loadCategorys();
    }, []);

    async function loadCategorys() {
        const response = await fetchCategories();

        if (response.statusCode !== 200) {
            return;
        }

        var data = response.data as Category[];

        setCategorys(data);
    }

    async function handleSave(category: Category) {
        const response = await addCategory(category);

        if (response.statusCode !== 200) {
            toast.error("Failed to add category");
            return;
        }

        toast.success("Category added successfully");
        loadCategorys();
    }

    const refresh = () => loadCategorys();

    return (
        <>
            <CategoryPageHeader
                categories={categories}
                handleSave={handleSave}
                show={true}
            />
            <div className="flex flex-col gap-10">
                <CategoryListTable categories={categories} refresh={refresh} />
            </div>
        </>
    );
}
